import {
  StatsigProvider as SP,
  useClientAsyncInit
} from '@statsig/react-bindings'
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics'
import { StatsigSessionReplayPlugin } from '@statsig/session-replay'

import { useAuth } from './AuthContext'

interface StatsigProviderProps {
  children: React.ReactNode
}

const STAGES = {
  dev: 'development',
  stag: 'staging',
  prod: 'production'
}

export function StatsigProvider({ children }: StatsigProviderProps) {
  const { user } = useAuth()

  const { client } = useClientAsyncInit(
    process.env.STATSIG_CLIENT_KEY,
    { userID: user.id },
    {
      environment: { tier: STAGES[process.env.STAGE] },
      plugins: [
        new StatsigAutoCapturePlugin(),
        new StatsigSessionReplayPlugin()
      ]
    }
  )

  return <SP client={client}>{children}</SP>
}
